import Vue from 'vue';
import {
  PaginationPlugin,
  DropdownPlugin,
  NavPlugin,
  NavbarPlugin,
  ModalPlugin,
  TablePlugin,
  FormSelectPlugin,
  SpinnerPlugin,
  BreadcrumbPlugin,
  FormCheckboxPlugin,
  FormRadioPlugin,
  ButtonPlugin,
  TooltipPlugin,
  TabsPlugin,
  CardPlugin,
  FormPlugin,
  AlertPlugin,
  FormGroupPlugin,
  FormInputPlugin,
  IconsPlugin,
} from 'bootstrap-vue';

import Vuelidate from 'vuelidate';
import VueMask from 'v-mask';
import VueRouter from 'vue-router';
import vco from 'v-click-outside';
import router from './router/index';
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import VueApexCharts from 'vue-apexcharts';
import VueSignaturePad from 'vue-signature-pad';
import Toast from 'vue-toastification';
import money from 'v-money';
import VueQRCodeComponent from 'vue-qrcode-component';
import VueTheMask from 'vue-the-mask';

// import VueHtmlToPaper from 'vue-html-to-paper';
// const options = {
//   name: '_blank',
//   specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
//   timeout: 1000,
//   autoClose: true,
// };

// Vue.use(VueHtmlToPaper, options);

import 'bootstrap-vue/dist/bootstrap-vue.css';
import '../src/design/app.scss';
import './utils/method';
import store from '@/state/store';
import App from './App.vue';
import i18n from './i18n';

Vue.use(VueRouter);
Vue.use(vco);
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);
Vue.config.productionTip = false;

Vue.use(DropdownPlugin);
Vue.use(PaginationPlugin);
Vue.use(NavPlugin);
Vue.use(NavbarPlugin);
Vue.use(ModalPlugin);
Vue.use(TablePlugin);
Vue.use(FormSelectPlugin);
Vue.use(SpinnerPlugin);
Vue.use(BreadcrumbPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormRadioPlugin);
Vue.use(ButtonPlugin);
Vue.use(TooltipPlugin);
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(FormPlugin);
Vue.use(AlertPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(IconsPlugin);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(VueSweetalert2);
Vue.component('apexchart', VueApexCharts);
Vue.use(VueSignaturePad);
Vue.use(VueTheMask);
Vue.component('qr-code', VueQRCodeComponent);
import 'vue-toastification/dist/index.css';
Vue.use(Toast, {
  transition: 'Vue-Toastification__bounce',
  containerClassName: 'toas-container',
  maxToasts: 20,
  newestOnTop: true,
});
Vue.use(money, {
  decimal: '.',
  thousands: ',',
  precision: 2,
  masked: false,
});

// router.app = Vue;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

// ngrok http 8081 -host-header="localhost:8081"
